var angular = require('angular');
var translate = require('js/lib/translate');

loginService.$inject = ['$rootScope', '$window', '$location', 'http', 'storage', 'config'];

function loginService($rootScope, $window, $location, http, storage, config) {

  $rootScope.username = storage.local.get('username');

  $rootScope.autoLogout = function() {
    storage.local.remove('auth');
    storage.session.remove('companyId');
    $window.location.reload();
  };

  $rootScope.logout = function() {
    storage.local.remove('auth');
    storage.session.remove('companyId');
    $window.location = '#/';
    $window.location.reload(true);
  };

  $rootScope.changeCompany = function(companyId) {
    storage.session.set('companyId', companyId);
    $window.location = '#/';
    $window.location.reload(true);
  };

  $rootScope.changeLanguage = function(languageId) {
    storage.local.set('languageId', languageId);
    translate.setLanguage(languageId);
  };

  this.initLanguage = function() {
    // Get language
    var languageId = storage.local.get('languageId');
    if (! languageId) {
      // Default - set to first language and save to local storage
      languageId = config.languages[0].id;
      storage.local.set('languageId', languageId);
    }
    translate.setLanguage(languageId); // Set language
    return languageId;
  };

  this.initLanguage();

  $rootScope.languageId = translate.getLanguage();
  $rootScope.languages = config.languages;

  var auth = function(username, password) {
    return http.post(['auth', 'generate'], {
      username: username,
      password: password
    }, [403]);  // 403 Forbidden
  };

  this.login = function(scope, username, password) {
    scope.isLoading = true;
    auth(username, password)
      .then(function(data) {
        var auth = angular.extend({}, data);

        var inRole = function(role) {
          return !! data.roles.filter(function(r) {
            return r === role;
          })[0];
        };

        auth.roles = {
          di: inRole('ROLE_di'),
          plannerPlus: inRole('ROLE_di') || inRole('ROLE_role.planandgo.plannerplus'),
          planner: inRole('ROLE_di') || inRole('ROLE_role.planandgo.plannerplus') || inRole('ROLE_role.planandgo.planner'),
          fleetManager: inRole('ROLE_di') || inRole('ROLE_role.planandgo.plannerplus') || inRole('ROLE_role.planandgo.planner') || inRole('ROLE_role.planandgo.fleetmanager'),
          clientPlus: !! auth.customerSystemIds && inRole('ROLE_role.planandgo.clientplus'),
          client: !! auth.customerSystemIds && (inRole('ROLE_role.planandgo.clientplus') || inRole('ROLE_role.planandgo.client')),
          customerService: inRole('ROLE_role.planandgo.customerservice')
        };

        if (auth.roles.client) auth.role = 'roleClient';
        if (auth.roles.clientPlus) auth.role = 'roleClientPlus';
        if (auth.roles.fleetManager) auth.role = 'roleFleetManager';
        if (auth.roles.planner) auth.role = 'rolePlanner';
        if (auth.roles.plannerPlus) auth.role = 'rolePlannerPlus';
        if (auth.roles.customerService) auth.role = 'roleCustomerService';

        if (! auth.role && inRole('ROLE_role.planandgo.driver')) {
          // Only driver
          scope.isLoading = false;
          scope.errorMsg = translate.t('loginErrorOnlyDriver');

        } else {
          // Success
          storage.local.set('auth', auth);
          storage.local.set('username', username);
          $rootScope.username = username;

          $location.path('/');

        }
      })
      .catch(function(error) {
        console.warn('login', error);
        scope.isLoading = false;
        scope.errorMsg = null;
        if (!! error.ignoredStatus) {
          scope.errorMsg = translate.t('loginError'); // Default error
          if (error.data && error.data.errorKey) {
            if (error.data.errorKey === 'user.account.expired') {
              scope.errorMsg = translate.t('loginErrorAccountExpired');
            } else if (error.data.errorKey === 'user.password.expired') {
              scope.errorMsg = translate.t('loginErrorPasswordExpired', scope.forgotPasswordURL(username));
            }
          }
        }
      });
  };

  var nextUrl;

  this.checkAuth = function() {

    var loadFromStorage = function() {
      var auth = storage.local.get('auth');

      if (auth) {
        auth.companyId = storage.session.get('companyId') || auth.companyId || (auth.companyIds && auth.companyIds.length ? auth.companyIds[0] : 0);
        $rootScope.auth = auth;
      }
    };

    $rootScope.$on('$locationChangeStart', function(event, url) {
      if (! $rootScope.auth) loadFromStorage();

      if (! $rootScope.auth && ! /\blogin\b/.test(url)) {
        nextUrl = $location.path();
        $window.location = '/v2/login';
      } else if ($rootScope.auth && nextUrl) {
        $location.path(nextUrl).replace();
        nextUrl = null;
      }
    });
  };

}

module.exports = loginService;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/login.js
 ** module id = 201
 ** module chunks = 1
 **/